{
  "version": 1,
  "asset_id": "a91da05c-ff45-4a76-96fc-9ff08a8f7465",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a91da05c-ff45-4a76-96fc-9ff08a8f7465/gastric-bypass-v2-1536.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a91da05c-ff45-4a76-96fc-9ff08a8f7465/gastric-bypass-v2-1536.webp",
  "original_filename": "gastric-bypass-v2-1536.webp",
  "size": 104888,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:00:59Z"
}
